import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, normalizeClass as _normalizeClass, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, mergeProps as _mergeProps } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "mt-6"
}
const _hoisted_2 = {
  key: 1,
  class: "mt-2"
}
const _hoisted_3 = { class: "mb-4" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", { class: "material-icons-outlined" }, "chevron_left", -1)
const _hoisted_5 = { class: "flex flex-start md:items-center" }
const _hoisted_6 = { class: "flex md:flex-row flex-col md:space-x-2 md:mt-0 mt-1 w-full" }
const _hoisted_7 = { class: "flex flex-col" }
const _hoisted_8 = {
  style: {"line-height":"1.1"},
  class: "mb-0 hidden md:block"
}
const _hoisted_9 = {
  style: {"line-height":"1.1"},
  class: "mb-0 md:hidden"
}
const _hoisted_10 = { class: "flex space-x-2 ml-0.5" }
const _hoisted_11 = {
  key: 0,
  class: "text-sm"
}
const _hoisted_12 = {
  key: 1,
  class: "text-muted text-sm"
}
const _hoisted_13 = { class: "ml-auto flex items-center" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("span", { class: "text-xl material-icons" }, " edit ", -1)
const _hoisted_15 = { class: "mx-2 md:mx-4" }
const _hoisted_16 = { class: "mt-8" }
const _hoisted_17 = { class: "mt-12" }
const _hoisted_18 = { key: 0 }
const _hoisted_19 = { class: "grid grid-cols-1 lg:grid-cols-2 gap-4 lg:gap-6" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SlotSkeleton = _resolveComponent("SlotSkeleton")!
  const _component_Btn = _resolveComponent("Btn")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_Timestamp = _resolveComponent("Timestamp")!
  const _component_CopyToClipboard = _resolveComponent("CopyToClipboard")!
  const _component_ProcessedTextFragment = _resolveComponent("ProcessedTextFragment")!
  const _component_CourseTreeNode = _resolveComponent("CourseTreeNode")!
  const _component_CourseTreeNodeCommentSection = _resolveComponent("CourseTreeNodeCommentSection")!

  return (_ctx.firstLoading)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_component_SlotSkeleton),
        _createVNode(_component_SlotSkeleton, { class: "mb-4 mt-2" }),
        _createVNode(_component_SlotSkeleton)
      ]))
    : (_openBlock(), _createElementBlock("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_router_link, {
            to: { name: 'CourseTreeDispatcher', params: { courseId: _ctx.courseId } }
          }, {
            default: _withCtx(() => [
              _createVNode(_component_Btn, {
                size: 'xs',
                variant: 'primary-borderless'
              }, {
                default: _withCtx(() => [
                  _hoisted_4,
                  _createTextVNode(" " + _toDisplayString(_ctx.$t("course_tree.back_to_tree")), 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["to"])
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", {
            style: {"min-width":"3.5rem","max-width":"3.5rem"},
            class: _normalizeClass(["flex rounded-full w-14 h-14 mr-3", {
					'bg-gray-200': _ctx.node.state === _ctx.AnnouncementNodeState.DRAFT,
					'bg-primary  bg-opacity-15': _ctx.node.state === _ctx.AnnouncementNodeState.PUBLISHED,
				}])
          }, [
            _createElementVNode("span", {
              style: {"font-size":"40px !important"},
              class: _normalizeClass(["m-auto material-icons-outlined", {
						'text-gray-500': _ctx.node.state === _ctx.AnnouncementNodeState.DRAFT,
						'text-primary': _ctx.node.state === _ctx.AnnouncementNodeState.PUBLISHED,
					}])
            }, "campaign", 2)
          ], 2),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("h1", _hoisted_8, _toDisplayString(_ctx.$t("course_tree.announcement_title")), 1),
              _createElementVNode("h3", _hoisted_9, _toDisplayString(_ctx.$t("course_tree.announcement_title")), 1),
              _createElementVNode("div", _hoisted_10, [
                (_ctx.node.creator)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_11, _toDisplayString(_ctx.node.creator.full_name), 1))
                  : _createCommentVNode("", true),
                _createVNode(_component_Timestamp, {
                  "date-only": true,
                  class: "text-sm text-muted",
                  value: _ctx.node.created
                }, null, 8, ["value"]),
                (_ctx.node.state === _ctx.AnnouncementNodeState.DRAFT)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_12, _toDisplayString(_ctx.$t("course_tree.draft")), 1))
                  : _createCommentVNode("", true)
              ])
            ]),
            _createElementVNode("div", _hoisted_13, [
              (_ctx.canEdit)
                ? (_openBlock(), _createBlock(_component_Btn, {
                    key: 0,
                    onClick: _ctx.onEdit,
                    variant: 'icon',
                    outline: true,
                    class: "icon-btn-primary hover:opacity-100 transition-opacity duration-100 ease opacity-50",
                    tooltip: _ctx.$t('misc.edit')
                  }, {
                    default: _withCtx(() => [
                      _hoisted_14
                    ]),
                    _: 1
                  }, 8, ["onClick", "tooltip"]))
                : _createCommentVNode("", true),
              _createVNode(_component_CopyToClipboard, {
                class: "hover:opacity-100 transition-opacity duration-100 ease opacity-50",
                "icon-only": true,
                tooltip: _ctx.$t('exercise_solution.share'),
                value: _ctx.permalink
              }, null, 8, ["tooltip", "value"])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_15, [
          _createElementVNode("div", _hoisted_16, [
            _createVNode(_component_ProcessedTextFragment, {
              value: _ctx.node.body
            }, null, 8, ["value"])
          ]),
          _createElementVNode("div", _hoisted_17, [
            (_ctx.loadingChildren)
              ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                  _createVNode(_component_SlotSkeleton),
                  _createVNode(_component_SlotSkeleton)
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_19, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.children, (child) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "",
                  key: child.id
                }, [
                  _createVNode(_component_CourseTreeNode, _mergeProps(_ctx.$props, {
                    node: child,
                    onDeleteNode: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('deleteNode', $event)))
                  }), null, 16, ["node"])
                ]))
              }), 128))
            ])
          ]),
          _createVNode(_component_CourseTreeNodeCommentSection, {
            loadingComments: _ctx.loadingComments,
            class: "mt-8",
            nodeId: _ctx.node.id
          }, null, 8, ["loadingComments", "nodeId"])
        ])
      ]))
}